const cityStudents = [
  {
    id: 'c01',
    name: '陈思远',
    city: '北京',
    school: '北京市第四中学',
    grade: '高三',
    subject: '数学竞赛',
    tag: '城市',
    tagColor: 'bg-red-100 text-red-700',
    content: '认识了云南的同学后，他们的刻苦精神让我重新审视自己，现在每天早起6点开始学习！',
    avatar: 'https://public.readdy.ai/ai/img_res/1afff97e372f66ec439dc06a3c4bfe55.jpg',
  },
  {
    id: 'c02',
    name: '苗翠花',
    city: '云南昭通',
    school: '昭通市第一中学',
    grade: '高二',
    subject: '英语口语',
    tag: '乡村',
    tagColor: 'bg-green-100 text-green-700',
    content: '北京同学教我做PPT演讲，我教他们唱彝族民歌，每周视频通话，英语进步了好多！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20girl%20student%20reading%20book%20in%20rural%20Yunnan%20school%20library%2C%20school%20uniform%2C%20warm%20natural%20light%20through%20window%2C%20wooden%20desk%2C%20sincere%20expression%2C%20realistic%20photo&width=400&height=300&seq=city002&orientation=landscape',
  },
  {
    id: 'c03',
    name: '王浩然',
    city: '上海',
    school: '上海中学国际部',
    grade: '高三',
    subject: '物理竞赛',
    tag: '城市',
    tagColor: 'bg-red-100 text-red-700',
    content: '甘肃同学在艰苦条件下坚持学习的精神深深感动了我，让我更加珍惜现在的学习资源。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20boy%20student%20working%20on%20physics%20experiment%20in%20modern%20Shanghai%20school%20lab%2C%20school%20uniform%2C%20concentrated%20look%2C%20science%20equipment%20on%20table%2C%20bright%20lab%20environment%2C%20realistic%20photo&width=400&height=300&seq=city003&orientation=landscape',
  },
  {
    id: 'c04',
    name: '李秀英',
    city: '甘肃定西',
    school: '定西市安定区第一中学',
    grade: '高一',
    subject: '语文写作',
    tag: '乡村',
    tagColor: 'bg-green-100 text-green-700',
    content: '上海同学帮我修改作文，教我用思维导图整理知识点，语文成绩从90分提升到118分！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20girl%20student%20writing%20in%20notebook%20at%20simple%20rural%20Gansu%20school%20classroom%2C%20school%20uniform%2C%20diligent%20expression%2C%20afternoon%20sunlight%2C%20modest%20classroom%20setting%2C%20realistic%20photo&width=400&height=300&seq=city004&orientation=landscape',
  },
  {
    id: 'c05',
    name: '赵子轩',
    city: '广州',
    school: '广州市执信中学',
    grade: '高二',
    subject: '化学竞赛',
    tag: '城市',
    tagColor: 'bg-red-100 text-red-700',
    content: '和贵州山区同学一起做线上学习小组，他们的专注力让我汗颜，现在我也戒掉了手机游戏！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20boy%20student%20studying%20chemistry%20at%20modern%20Guangzhou%20school%20desk%2C%20school%20uniform%2C%20bright%20smile%2C%20colorful%20periodic%20table%20poster%20on%20wall%2C%20well-equipped%20classroom%2C%20realistic%20photo&width=400&height=300&seq=city005&orientation=landscape',
  },
  {
    id: 'c06',
    name: '吴小梅',
    city: '贵州黔东南',
    school: '凯里市第一中学',
    grade: '高三',
    subject: '生物竞赛',
    tag: '乡村',
    tagColor: 'bg-green-100 text-green-700',
    content: '广州同学分享了很多课外书单，我们一起参加线上模拟考试，今年我考上了中山大学！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20girl%20student%20reading%20biology%20textbook%20in%20Guizhou%20rural%20school%20classroom%2C%20school%20uniform%2C%20happy%20expression%2C%20green%20plants%20outside%20window%2C%20simple%20but%20tidy%20classroom%2C%20realistic%20photo&width=400&height=300&seq=city006&orientation=landscape',
  },
  {
    id: 'c07',
    name: '刘宇航',
    city: '成都',
    school: '成都七中',
    grade: '高三',
    subject: '历史竞赛',
    tag: '城市',
    tagColor: 'bg-red-100 text-red-700',
    content: '认识西藏同学后，我把自己整理的笔记全部分享给他，希望能帮到更多需要帮助的人。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20boy%20student%20reviewing%20history%20notes%20in%20Chengdu%20school%20study%20room%2C%20school%20uniform%2C%20friendly%20expression%2C%20bookshelves%20behind%2C%20warm%20indoor%20lighting%2C%20realistic%20photo&width=400&height=300&seq=city007&orientation=landscape',
  },
  {
    id: 'c08',
    name: '扎西顿珠',
    city: '西藏拉萨',
    school: '拉萨市第一中学',
    grade: '高二',
    subject: '地理竞赛',
    tag: '乡村',
    tagColor: 'bg-green-100 text-green-700',
    content: '成都同学教我用思维导图学历史，我们的友谊跨越3000公里，学习也变得更有趣了！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20Tibetan%20teenage%20boy%20student%20studying%20geography%20with%20map%20in%20Lhasa%20school%20classroom%2C%20school%20uniform%2C%20warm%20smile%2C%20Tibetan%20cultural%20elements%20in%20background%2C%20bright%20classroom%2C%20realistic%20photo&width=400&height=300&seq=city008&orientation=landscape',
  },
  {
    id: 'c09',
    name: '孙雨萌',
    city: '杭州',
    school: '杭州学军中学',
    grade: '高一',
    subject: '信息技术',
    tag: '城市',
    tagColor: 'bg-red-100 text-red-700',
    content: '和宁夏同学一起学编程，她学得特别快！我们约好一起考计算机竞赛，每天都在进步。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20girl%20student%20coding%20on%20computer%20in%20Hangzhou%20school%20computer%20lab%2C%20school%20uniform%2C%20cheerful%20expression%2C%20multiple%20monitors%2C%20modern%20tech%20classroom%20environment%2C%20realistic%20photo&width=400&height=300&seq=city009&orientation=landscape',
  },
  {
    id: 'c10',
    name: '马晓燕',
    city: '宁夏固原',
    school: '固原市第一中学',
    grade: '高一',
    subject: '数学竞赛',
    tag: '乡村',
    tagColor: 'bg-green-100 text-green-700',
    content: '杭州同学帮我找到很多免费编程资源，我们每周末一起做题，平台让我看见了更广阔的世界！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20girl%20student%20solving%20math%20problems%20at%20desk%20in%20Ningxia%20rural%20school%2C%20school%20uniform%2C%20sincere%20focused%20expression%2C%20chalk%20blackboard%20in%20background%2C%20simple%20classroom%2C%20realistic%20photo&width=400&height=300&seq=city010&orientation=landscape',
  },
  {
    id: 'c11',
    name: '林俊杰',
    city: '深圳',
    school: '深圳中学',
    grade: '高二',
    subject: '英语演讲',
    tag: '城市',
    tagColor: 'bg-red-100 text-red-700',
    content: '认识了内蒙古的同学，他骑马上学的故事让我震撼，我们互相分享生活，视野都开阔了！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20boy%20student%20practicing%20English%20speech%20in%20modern%20Shenzhen%20school%20auditorium%2C%20school%20uniform%2C%20confident%20posture%2C%20microphone%20stand%2C%20bright%20stage%20lighting%2C%20realistic%20photo&width=400&height=300&seq=city011&orientation=landscape',
  },
  {
    id: 'c12',
    name: '乌日娜',
    city: '内蒙古呼伦贝尔',
    school: '海拉尔第一中学',
    grade: '高二',
    subject: '语文写作',
    tag: '乡村',
    tagColor: 'bg-green-100 text-green-700',
    content: '深圳同学教我做视频剪辑，我教他蒙古族文化，我们的友谊让我更有勇气走向更大的舞台！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20Mongolian%20teenage%20girl%20student%20writing%20essay%20in%20Inner%20Mongolia%20school%20classroom%2C%20school%20uniform%2C%20grassland%20scenery%20visible%20through%20window%2C%20warm%20expression%2C%20wooden%20desk%2C%20realistic%20photo&width=400&height=300&seq=city012&orientation=landscape',
  },
  {
    id: 'c13',
    name: '黄思琪',
    city: '南京',
    school: '南京外国语学校',
    grade: '高三',
    subject: '法语',
    tag: '城市',
    tagColor: 'bg-red-100 text-red-700',
    content: '和新疆的同学互相学习，她的维吾尔族刺绣让我着迷，我们约好大学毕业后一起去旅行！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20girl%20student%20studying%20foreign%20language%20textbook%20in%20Nanjing%20school%20language%20lab%2C%20school%20uniform%2C%20focused%20expression%2C%20language%20learning%20posters%20on%20wall%2C%20modern%20classroom%2C%20realistic%20photo&width=400&height=300&seq=city013&orientation=landscape',
  },
  {
    id: 'c14',
    name: '阿依古丽',
    city: '新疆喀什',
    school: '喀什市第二中学',
    grade: '高三',
    subject: '数学',
    tag: '乡村',
    tagColor: 'bg-green-100 text-green-700',
    content: '南京同学帮我练习普通话演讲，我的数学成绩也在她的鼓励下从95分提升到了138分！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20Uyghur%20teenage%20girl%20student%20doing%20math%20exercises%20in%20Xinjiang%20Kashgar%20school%20classroom%2C%20school%20uniform%2C%20determined%20expression%2C%20desert%20landscape%20outside%20window%2C%20bright%20classroom%2C%20realistic%20photo&width=400&height=300&seq=city014&orientation=landscape',
  },
  {
    id: 'c15',
    name: '周子墨',
    city: '武汉',
    school: '华中师范大学附属中学',
    grade: '高三',
    subject: '生物竞赛',
    tag: '城市',
    tagColor: 'bg-red-100 text-red-700',
    content: '和广西同学一起备考，她的壮族山歌让我放松心情，我们互相打气，一起冲刺高考！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20boy%20student%20examining%20biology%20specimens%20under%20microscope%20in%20Wuhan%20school%20science%20lab%2C%20school%20uniform%2C%20curious%20expression%2C%20lab%20equipment%2C%20well-lit%20laboratory%2C%20realistic%20photo&width=400&height=300&seq=city015&orientation=landscape',
  },
  {
    id: 'c16',
    name: '韦秀兰',
    city: '广西百色',
    school: '百色市第一高级中学',
    grade: '高三',
    subject: '化学',
    tag: '乡村',
    tagColor: 'bg-green-100 text-green-700',
    content: '武汉同学分享了很多竞赛资料，我的化学成绩突飞猛进，今年成功考入了武汉大学！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20Zhuang%20teenage%20girl%20student%20studying%20chemistry%20in%20Guangxi%20rural%20school%20classroom%2C%20school%20uniform%2C%20happy%20smile%2C%20karst%20mountain%20scenery%20outside%20window%2C%20simple%20classroom%2C%20realistic%20photo&width=400&height=300&seq=city016&orientation=landscape',
  },
  {
    id: 'c17',
    name: '沈浩宇',
    city: '苏州',
    school: '苏州中学',
    grade: '高二',
    subject: '物理竞赛',
    tag: '城市',
    tagColor: 'bg-red-100 text-red-700',
    content: '和青海同学一起做物理题，他的认真劲儿感染了我，我们约好一起考清华物理系！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20boy%20student%20solving%20physics%20problems%20at%20desk%20in%20elegant%20Suzhou%20school%20study%20hall%2C%20school%20uniform%2C%20serious%20expression%2C%20classical%20garden%20visible%20through%20window%2C%20realistic%20photo&width=400&height=300&seq=city017&orientation=landscape',
  },
  {
    id: 'c18',
    name: '才让卓玛',
    city: '青海玉树',
    school: '玉树市第一民族中学',
    grade: '高二',
    subject: '数学',
    tag: '乡村',
    tagColor: 'bg-green-100 text-green-700',
    content: '苏州同学教我用APP刷题，我的数学成绩从80分提升到了125分，感谢这个平台！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20Tibetan%20teenage%20girl%20student%20studying%20math%20in%20Qinghai%20Yushu%20school%20classroom%2C%20school%20uniform%2C%20determined%20smile%2C%20high%20altitude%20plateau%20scenery%20outside%20window%2C%20simple%20school%20setting%2C%20realistic%20photo&width=400&height=300&seq=city018&orientation=landscape',
  },
  {
    id: 'c19',
    name: '郑雅婷',
    city: '厦门',
    school: '厦门双十中学',
    grade: '高一',
    subject: '英语写作',
    tag: '城市',
    tagColor: 'bg-red-100 text-red-700',
    content: '和黑龙江同学互相学习，她的东北话让我笑到肚子疼，但她的努力精神让我深受感动！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20girl%20student%20writing%20English%20essay%20in%20bright%20Xiamen%20school%20classroom%20near%20sea%2C%20school%20uniform%2C%20cheerful%20expression%2C%20ocean%20view%20through%20window%2C%20modern%20classroom%2C%20realistic%20photo&width=400&height=300&seq=city019&orientation=landscape',
  },
  {
    id: 'c20',
    name: '王大鹏',
    city: '黑龙江齐齐哈尔',
    school: '齐齐哈尔市第一中学',
    grade: '高一',
    subject: '语文',
    tag: '乡村',
    tagColor: 'bg-green-100 text-green-700',
    content: '厦门同学帮我练习英语写作，我教她东北文化，我们的友谊让我更有信心走出大山！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20boy%20student%20reading%20Chinese%20literature%20book%20in%20Heilongjiang%20school%20classroom%20in%20winter%2C%20school%20uniform%2C%20warm%20smile%2C%20snow%20scenery%20outside%20window%2C%20cozy%20classroom%20with%20heating%2C%20realistic%20photo&width=400&height=300&seq=city020&orientation=landscape',
  },
];

export default function CitiesSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-red-50 border border-red-100 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-map-pin-2-line text-red-500 text-sm"></i>
            <span className="text-red-600 text-xs font-semibold tracking-wide">全国二十城 · 城乡共学</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3">
            来自不同城市的同学，<br className="hidden md:block" />在各自的学校里，共同奋斗
          </h2>
          <p className="text-gray-500 text-sm max-w-xl mx-auto leading-relaxed">
            城市孩子学会感恩与珍惜，乡村孩子获得更广阔的视野。跨越地域的友谊，让每一个孩子都能金榜题名。
          </p>
        </div>

        {/* Student Grid — landscape school photos, 4 cols */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cityStudents.map((student) => (
            <div
              key={student.id}
              className="group bg-[#faf9f7] rounded-2xl overflow-hidden hover:scale-[1.02] transition-all duration-300 cursor-pointer"
            >
              {/* School photo */}
              <div className="relative w-full h-40 overflow-hidden">
                <img
                  src={student.avatar}
                  alt={`${student.name} 在${student.school}学习`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {/* City + tag overlay */}
                <div className="absolute top-2.5 left-2.5 flex items-center gap-1.5">
                  <span className={`text-[10px] px-2 py-0.5 rounded-full font-semibold ${student.tagColor}`}>
                    {student.tag}
                  </span>
                </div>
                <div className="absolute top-2.5 right-2.5 flex items-center gap-1 bg-black/40 rounded-full px-2 py-0.5">
                  <i className="ri-map-pin-line text-white text-[10px]"></i>
                  <span className="text-white text-[10px] font-medium">{student.city}</span>
                </div>
              </div>

              {/* Info */}
              <div className="p-4">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <p className="font-bold text-gray-900 text-sm">{student.name}</p>
                    <p className="text-gray-400 text-[11px] mt-0.5 leading-tight">{student.school}</p>
                  </div>
                  <div className="text-right flex-shrink-0 ml-2">
                    <span className="text-[10px] bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full font-medium">{student.grade}</span>
                    <p className="text-gray-400 text-[10px] mt-1">{student.subject}</p>
                  </div>
                </div>
                <p className="text-gray-500 text-[11px] leading-relaxed line-clamp-2">
                  &ldquo;{student.content}&rdquo;
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom stats */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-6">
          {[
            { icon: 'ri-map-2-line', label: '覆盖全国31个省市', color: 'text-red-500' },
            { icon: 'ri-team-line', label: '城乡学生互助配对', color: 'text-green-600' },
            { icon: 'ri-heart-line', label: '10万+跨城学伴', color: 'text-amber-500' },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-2 bg-[#faf9f7] rounded-full px-5 py-2.5">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} ${item.color} text-base`}></i>
              </div>
              <span className="text-gray-700 text-sm font-medium">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
